export enum EPlacement {
  auto = 'auto',
  top = 'top',
  bottom = 'bottom',
  left = 'left',
  right = 'right',
  topLeft = 'top left',
  topRight = 'top right',
  bottomLeft = 'bottom left',
  bottomRight = 'bottom right',
  leftTop = 'left top',
  leftBottom = 'left bottom',
  rightTop = 'right top',
  rightBottom = 'right bottom',
}
